import component from './GuestsRoomsChildrenSelect';

export default component;
